import styled, {css} from "styled-components"

import Card from "@irati/ui/src/Layout/Card"

export const GradientCard = styled(Card)`
  ${({theme}) => css`
    background-image: linear-gradient(to right, ${theme.colors.primary2}, ${theme.colors.secondary1});
    padding: ${theme.spacing.five};
    margin-bottom: ${theme.spacing.five};
    border-radius: 8px;
  `}
`

export const SpanLink = styled.span.attrs(() => ({
  role: "link",
  tabIndex: 0
}))`
  text-decoration: underline;
  cursor: pointer;
`
